import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useSearchParams } from "react-router-dom";
// import ReactSlider from "react-slider";
import {
  useGetCategorieHierachies,
  // useGetCategories,
  useGetProducts,
} from "../../hooks/useProducts";
import { getVisiblePages, numberFormatter } from "../../helper/helpers";
import { addToCart } from "../../Features/Cart/cartActions";
import PrescriptionModal from "./PrescriptionModal";
import Pagination from "./pagination";
import { AlertComponent } from "./AlertComponent";
import QuantityControl from "./QuantityControl";
import { ChevronDown } from "lucide-react";
import { slugify } from "../../utils/slugify";

const ShopSectionMain = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [pageIndex, setPageIndex] = useState(0);
  const [openCategory, setOpenCategory] = useState(null);

  const [pageData, setPageData] = useState({
    // pageIndex: 0,
    pageSize: 20,
    onlyPrescription: location?.pathname === "/products/prescription-products",
    onlyInStock: true,
  });

  const [isPrescriptionModal, setIsPrescriptionModal] = useState(false);
  const [sliderValue, setSliderValue] = useState({
    minPrice: 1,
    maxPrice: 1000,
  });
  // const [selectedProduct, setSelectedProduct] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  let [grid, setGrid] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

  const allSearchParams = useMemo(() => {
    return Object.fromEntries(searchParams.entries());
  }, [searchParams]);

  const queryParams = useMemo(() => {
    return {
      ...pageData,
      // pageIndex: Number(pageIndex),
      pageSize: Number(pageData.pageSize),
      ...allSearchParams,
    };
  }, [pageData, allSearchParams]);

  const categoryName = searchParams.get("category") ?? "";

  const sortBy = searchParams.get("sortBy") ?? "bestsellers";

  const { cart = [], error } = useSelector((state) => state.itemCart);

  const [sort, setSortBy] = useState(sortBy);

  const {
    data = {},
    isError: prdouctsIsError,
    error: productsError,
  } = useGetProducts({ ...queryParams, pageIndex });

  const {
    data: categories = {},
    isError: categoriesIsError,
    error: categoriesError,
  } = useGetCategorieHierachies();

  let { data: products = [] } = data?.products ?? {};
  let totalItemCount = data?.products?.count ?? 0;
  const totalPages = Math.ceil(totalItemCount / pageData.pageSize);

  // let categoryData = categories.categories ?? [];
  let { categories: categoryData = [] } = categories;

  const handlePrice = (event) => {
    const { name, value } = event.target;
    setSliderValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePagination = (value) => {
    let nextPage = pageIndex + 1;
    if (value === "add") {
      nextPage += 1;
    } else if (value === "minus") {
      nextPage -= 1;
    } else {
      nextPage = value;
    }
    nextPage = Math.max(0, Math.min(nextPage, totalPages));

    setPageIndex(nextPage);

    setPageIndex(nextPage);
    setSearchParams((prev) => {
      const params = Object.fromEntries(prev.entries());

      const updated = {
        ...params,
        pageIndex: nextPage,
      };

      // optional: clean empty values
      Object.keys(updated).forEach((key) => {
        if (
          updated[key] === undefined ||
          updated[key] === null ||
          updated[key] === ""
        ) {
          delete updated[key];
        }
      });

      return updated;
    });
  };

  const handleFilterByPrice = () => {
    setSearchParams((prev) => {
      const params = Object.fromEntries(prev.entries());

      const updated = {
        ...params,
        minPrice: sliderValue.minPrice,
        maxPrice: sliderValue.maxPrice,
      };

      // optional: clean empty values
      Object.keys(updated).forEach((key) => {
        if (
          updated[key] === undefined ||
          updated[key] === null ||
          updated[key] === ""
        ) {
          delete updated[key];
        }
      });

      return updated;
    });
  };

  const handleSortBy = (e) => {
    const { value } = e.target;
    setSortBy(value);
    setSearchParams((prev) => {
      const params = Object.fromEntries(prev.entries());

      const updated = {
        ...params,
        sortBy: value,
      };

      // optional: clean empty values
      Object.keys(updated).forEach((key) => {
        if (
          updated[key] === undefined ||
          updated[key] === null ||
          updated[key] === ""
        ) {
          delete updated[key];
        }
      });

      return updated;
    });
  };

  const handleAddtoCart = (item) => {
    dispatch(addToCart({ ...item, quantity: 1 }));
  };

  const NoProductComponent = () => {
    return (
      <div className="container text-center">
        <img
          src="/assets/images/illustrations/19.svg"
          width={300}
          alt="Logo"
          className="img-fluid"
        />
        <h6 className="mt-20">No products available</h6>
      </div>
    );
  };

  let path =
    location?.pathname === "/products/prescription-products"
      ? "/products/prescription-products"
      : "/products/category";

  const handlePrescriptionModal = () => {
    setIsPrescriptionModal(!isPrescriptionModal);
  };

  const hasNextPage = () => {
    return pageIndex + 1 >= totalPages;
  };

  const visiblePages = getVisiblePages(pageIndex, totalPages);

  const toggleCategory = (categoryId) => {
    setOpenCategory((prev) => (prev === categoryId ? null : categoryId));
  };

  React.useEffect(() => {
    const errs = [];

    if (prdouctsIsError) errs.push(`Products: ${productsError}`);
    if (categoriesIsError) errs.push(`categories: ${categoriesError}`);

    setErrorArray(errs);
  }, [prdouctsIsError, productsError, categoriesIsError, categoriesError]);

  // if(prdouctsIsError){
  //   return (
  //     <section className="shop py-80 bg-grey-50">
  //       <div className={`side-overlay ${active && "show"}`}></div>
  //       <div className="container container-lg">

  //       </div>
  //     </section>
  //   );
  // }

  return (
    <section className="shop py-80 bg-grey-50">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        {prdouctsIsError && <AlertComponent errorArray={errorArray} />}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${active && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <i className="ph ph-x" />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-20 mb-32">
                <div className="card mb-16">
                  <div className="card-body d-flex justify-content-between">
                    <div>
                      <p className="text-xs">Show Available Products</p>
                      <p className="text-xs">Only show products in stock</p>
                    </div>
                    <div className="form-check form-switch align-content-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={pageData.onlyInStock}
                        onChange={() =>
                          setPageData((prevData) => ({
                            ...prevData,
                            onlyInStock: !prevData.onlyInStock,
                          }))
                        }
                        // disabled
                      />
                    </div>
                  </div>
                </div>
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Product Category
                </h6>

                <div className="category-dropdown max-h-300 overflow-y-auto scroll-sm">
                  {categoryData.map((category) => {
                    const hasChildren = category.children?.length > 0;

                    return (
                      <div key={category.id} className="category-item">
                        {/* Parent category */}
                        <button
                          type="button"
                          onClick={() =>
                            hasChildren && toggleCategory(category.id)
                          }
                          className={`category-button py-3 px-8 rounded-pill text-sm ${!hasChildren ? "category-button--leaf" : ""}`}
                          aria-expanded={
                            hasChildren
                              ? openCategory === category.id
                              : undefined
                          }
                          aria-controls={
                            hasChildren ? `category-${category.id}` : undefined
                          }
                        >
                          {!hasChildren ? (
                            <Link
                              to={`${path}?category=${encodeURIComponent(category.name)}&categoryId=${category.name === "All products" ? "" : category.id}`}
                              // className={`text-gray-900 hover-text-main-600 text-sm ${categoryName === child.name && "rounded-pill text-main-600 bg-main-50"}`}
                              className={`text-gray-900 hover-text-main-600 text-sm`}
                            >
                              {category.name}
                            </Link>
                          ) : (
                            <span>{category.name}</span>
                          )}

                          {hasChildren && (
                            <ChevronDown
                              size={18}
                              className={
                                openCategory === category.id ? "rotate" : ""
                              }
                            />
                          )}
                        </button>
                        {/* Children */}
                        {hasChildren && openCategory === category.id && (
                          <ul
                            id={`category-${category.id}`}
                            className="category-children"
                          >
                            {category.children.map((child) => (
                              <li key={child.id} className="child-category">
                                <Link
                                  to={`${path}?category=${encodeURIComponent(child.name)}&categoryId=${child.id}`}
                                  className={`text-gray-900 hover-text-main-600 text-sm ${categoryName === child.name && "rounded-pill text-main-600 bg-main-50"}`}
                                  // className={`mb-16 ${categoryName === child.name && "rounded-pill text-main-600 bg-main-50"}`}
                                >
                                  {child.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })}
                </div>
                {/* <ul className="max-h-300 overflow-y-auto scroll-sm">
                  {categoryData?.map((category) => (
                    <li
                      className={`mb-16 ${categoryName === category.name && "py-2 px-8 rounded-pill text-main-600 bg-main-50"}`}
                      key={category?.id}
                    >
                      <Link
                        to={`${path}?category=${category?.name}&categoryId=${category?.id}`}
                        className={`text-gray-900 hover-text-main-600 text-sm`}
                      >
                        {category?.name}
                      </Link>
                    </li>
                  ))}
                </ul> */}
                {/* <ul className="max-h-540 overflow-y-auto scroll-sm">
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Mobile &amp; Accessories (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Laptop (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Electronics (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Smart Watch (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Storage (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Portable Devices (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Action Camera (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Smart Gadget (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Monitor (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Smart TV (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Camera (12)
                    </Link>
                  </li>
                  <li className="mb-24">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Monitor Stand (12)
                    </Link>
                  </li>
                  <li className="mb-0">
                    <Link
                      to="/product-details-two"
                      className="text-gray-900 hover-text-main-600"
                    >
                      Headphone (12)
                    </Link>
                  </li>
                </ul> */}
              </div>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-20 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Price (Ksh)
                </h6>
                <div>
                  <div className="row g-3">
                    <div className="col">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Min"
                        step={"any"}
                        max={sliderValue.maxPrice}
                        name="minPrice"
                        value={sliderValue.minPrice}
                        onChange={handlePrice}
                      />
                    </div>
                    <div className="col">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Max"
                        step={"any"}
                        name="maxPrice"
                        min={sliderValue.minPrice}
                        value={sliderValue.maxPrice}
                        onChange={handlePrice}
                      />
                    </div>
                  </div>
                  <div className="flex-between flex-wrap-reverse gap-8 mt-24 ">
                    <button
                      type="button"
                      className="btn btn-sm h-40 w-100 text-center bg-gray-50 text-heading hover-bg-main-600 hover-text-white rounded-pill"
                      onClick={handleFilterByPrice}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                {/* <div className="custom--range">
                  <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    defaultValue={[0, 100]}
                    ariaLabel={["Lower thumb", "Upper thumb"]}
                    ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
                    renderThumb={(props, state) => {
                      const { key, ...restProps } = props;
                      return (
                        <div {...restProps} key={state.index}>
                          {state.valueNow}
                        </div>
                      );
                    }}
                    pearling
                    minDistance={10}
                  />

                  <br />
                  <br />
                  <div className="flex-between flex-wrap-reverse gap-8 mt-24 ">
                    <button
                      type="button"
                      className="btn btn-main h-40 flex-align"
                    >
                      Filter
                    </button>
                  </div>
                </div> */}
              </div>

              {/* <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Rating
                </h6>
                <div className="flex-align gap-8 position-relative mb-20">
                  <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating5"
                  >
                    {" "}
                  </label>
                  <div className="common-check common-radio mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="rating5"
                    />
                  </div>
                  <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={70}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="progress-bar bg-main-600 rounded-pill"
                      style={{ width: "70%" }}
                    />
                  </div>
                  <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                  </div>
                  <span className="text-gray-900 flex-shrink-0">124</span>
                </div>
                <div className="flex-align gap-8 position-relative mb-20">
                  <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating4"
                  >
                    {" "}
                  </label>
                  <div className="common-check common-radio mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="rating4"
                    />
                  </div>
                  <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={50}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="progress-bar bg-main-600 rounded-pill"
                      style={{ width: "50%" }}
                    />
                  </div>
                  <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                  </div>
                  <span className="text-gray-900 flex-shrink-0">52</span>
                </div>
                <div className="flex-align gap-8 position-relative mb-20">
                  <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating3"
                  >
                    {" "}
                  </label>
                  <div className="common-check common-radio mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="rating3"
                    />
                  </div>
                  <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={35}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="progress-bar bg-main-600 rounded-pill"
                      style={{ width: "35%" }}
                    />
                  </div>
                  <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                  </div>
                  <span className="text-gray-900 flex-shrink-0">12</span>
                </div>
                <div className="flex-align gap-8 position-relative mb-20">
                  <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating2"
                  >
                    {" "}
                  </label>
                  <div className="common-check common-radio mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="rating2"
                    />
                  </div>
                  <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={20}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="progress-bar bg-main-600 rounded-pill"
                      style={{ width: "20%" }}
                    />
                  </div>
                  <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                  </div>
                  <span className="text-gray-900 flex-shrink-0">5</span>
                </div>
                <div className="flex-align gap-8 position-relative mb-0">
                  <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating1"
                  >
                    {" "}
                  </label>
                  <div className="common-check common-radio mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="rating1"
                    />
                  </div>
                  <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={5}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <div
                      className="progress-bar bg-main-600 rounded-pill"
                      style={{ width: "5%" }}
                    />
                  </div>
                  <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                  </div>
                  <span className="text-gray-900 flex-shrink-0">2</span>
                </div>
              </div>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Color
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-black">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color1"
                      />
                      <label className="form-check-label" htmlFor="color1">
                        Black(12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-primary">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color2"
                      />
                      <label className="form-check-label" htmlFor="color2">
                        Blue (12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-gray">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color3"
                      />
                      <label className="form-check-label" htmlFor="color3">
                        Gray (12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-success">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color4"
                      />
                      <label className="form-check-label" htmlFor="color4">
                        Green (12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-danger">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color5"
                      />
                      <label className="form-check-label" htmlFor="color5">
                        Red (12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio checked-white">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color6"
                      />
                      <label className="form-check-label" htmlFor="color6">
                        White (12)
                      </label>
                    </div>
                  </li>
                  <li className="mb-0">
                    <div className="form-check common-check common-radio checked-purple">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="color7"
                      />
                      <label className="form-check-label" htmlFor="color7">
                        Purple (12)
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Brand
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="brand1"
                      />
                      <label className="form-check-label" htmlFor="brand1">
                        Apple
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="brand2"
                      />
                      <label className="form-check-label" htmlFor="brand2">
                        Samsung
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="brand3"
                      />
                      <label className="form-check-label" htmlFor="brand3">
                        Microsoft
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="brand4"
                      />
                      <label className="form-check-label" htmlFor="brand4">
                        Apple
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="brand5"
                      />
                      <label className="form-check-label" htmlFor="brand5">
                        HP
                      </label>
                    </div>
                  </li>
                  <li className="mb-24">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="DELL"
                      />
                      <label className="form-check-label" htmlFor="DELL">
                        DELL
                      </label>
                    </div>
                  </li>
                  <li className="mb-0">
                    <div className="form-check common-check common-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="color"
                        id="Redmi"
                      />
                      <label className="form-check-label" htmlFor="Redmi">
                        Redmi
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="shop-sidebar__box rounded-8">
                <img src="assets/images/thumbs/advertise-img1.png" alt="" />
              </div> */}
            </div>
          </div>
          {/* Sidebar End */}
          {/* Content Start */}
          <div className="col-lg-9 d-flex flex-column">
            {/* Top Start */}
            <div className="flex-between gap-16 flex-wrap mb-40 ">
              <span className="text-gray-900">
                Showing <strong>{pageData.pageIndex}</strong>
                <strong>{totalPages}</strong> of{" "}
                <strong>
                  {new Intl.NumberFormat("en-GB").format(
                    Number(totalItemCount),
                  )}
                </strong>{" "}
                result{" "}
                {categoryName && (
                  <>
                    <span>of</span> <em className="fw-bold">{categoryName}</em>
                  </>
                )}
              </span>
              {/* <span className="text-gray-900">Showing 1-20 of 85 result</span> */}
              <div className="position-relative flex-align gap-16 flex-wrap">
                <div className="list-grid-btns flex-align gap-16">
                  <button
                    className="btn btn-sm btn-danger py-8 d-none d-md-block"
                    type="button"
                    onClick={handlePrescriptionModal}
                  >
                    <i className="ph ph-file-arrow-up me-5"></i>
                    Upload Prescription
                  </button>
                  <button
                    onClick={() => setGrid(true)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${grid === true && "border-main-600 text-white bg-main-600"}`}
                  >
                    <i className="ph-bold ph-list-dashes" />
                  </button>
                  <button
                    onClick={() => setGrid(false)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${grid === false && "border-main-600 text-white bg-main-600"}`}
                  >
                    <i className="ph ph-squares-four" />
                  </button>
                </div>
                <button
                  className="btn btn-sm btn-danger py-8 d-sm-block d-md-none"
                  type="button"
                  onClick={handlePrescriptionModal}
                >
                  <i className="ph ph-file-arrow-up me-5"></i>
                  Upload Prescription
                </button>
                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                  <label
                    htmlFor="sorting"
                    className="text-inherit flex-shrink-0"
                  >
                    Sort by:{" "}
                  </label>
                  <select
                    className="form-control form-control-sm text-inherit rounded-6 w-auto"
                    id="sorting"
                    value={sort}
                    onChange={handleSortBy}
                  >
                    <option value={"bestsellers"}>Best Sellers</option>
                    <option value={"dealoftheday"}>Deal of the Day</option>
                    <option value={"newest"}>Newest</option>
                  </select>
                </div>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                >
                  <i className="ph-bold ph-funnel" />
                </button>
              </div>
            </div>
            {/* Top End */}
            {products.length === 0 ? (
              NoProductComponent()
            ) : (
              <div className={`list-grid-wrapper ${grid && "list-view"}`}>
                {products?.map((product) => {
                  const cartItem = cart.find(
                    (item) =>
                      String(item?.id) === String(product?.id) ||
                      String(item?.productId) === String(product?.id),
                  );

                  return (
                    <div
                      className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2"
                      key={product?.id}
                    >
                      <Link
                        to={`/products/product-details/${product?.id}?name=${slugify(product?.name)}`}
                        // to={`/products/product-details/${slugify(product?.name)}`}
                        state={product}
                        className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                      >
                        <img
                          src={
                            product?.imageUrl ??
                            "/assets/images/thumbs/product-two-img2.png"
                          }
                          alt={product?.name}
                          //   className="w-auto max-w-unset"
                          className="img-fluid w-auto"
                        />
                        {/* <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                      Best Sale{" "}
                    </span> */}
                        {product?.stockQuantity === 0 && (
                          <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                            Out of Stock
                          </span>
                        )}
                        {product?.isDealOfTheDay && (
                          <span className="product-card__badge bg-success-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                            Deal of the Day
                          </span>
                        )}
                      </Link>
                      <div className="product-card__content mt-16 w-100">
                        <h6 className="title text-md fw-semibold mt-12 mb-8">
                          <Link
                            to={`/products/product-details/${product?.id}?name=${slugify(product?.name)}`}
                            // to={`/products/product-details/${slugify(product?.name)}`}
                            state={product}
                            className="link text-line-2"
                            tabIndex={0}
                          >
                            {product?.name}
                          </Link>
                        </h6>
                        {/* <div className="flex-align mb-20 mt-16 gap-6">
                      <span className="text-xs fw-medium text-gray-500">
                        4.8
                      </span>
                      <span className="text-15 fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                      </span>
                      <span className="text-xs fw-medium text-gray-500">
                        (17k)
                      </span>
                    </div>
                    <div className="mt-8">
                      <div
                        className="progress w-100 bg-color-three rounded-pill h-4"
                        role="progressbar"
                        aria-label="Basic example"
                        aria-valuenow={35}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-main-two-600 rounded-pill"
                          style={{ width: "35%" }}
                        />
                      </div>
                      <span className="text-gray-900 text-xs fw-medium mt-8">
                        Sold: 18/35
                      </span>
                    </div> */}
                        <div className="product-card__price my-20">
                          {/* <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                        $28.99
                      </span> */}
                          <span className="text-heading text-sm fw-semibold ">
                            {numberFormatter.format(Number(product?.price))}{" "}
                            <span className="text-gray-500 fw-normal">
                              /Qty
                            </span>{" "}
                          </span>
                        </div>
                        {product?.stockQuantity === 0 && (
                          <p className="text-danger-600 text-sm">
                            Out of Stock
                          </p>
                        )}
                        {product?.isPrescription ? (
                          <button
                            tabIndex={0}
                            className="product-card__cart btn text-white bg-danger-600 hover-bg-red-600 hover-text-white py-11 px-24 rounded-pill flex-center gap-8 fw-medium w-100"
                            disabled
                          >
                            Prescription Required
                          </button>
                        ) : cartItem ? null : (
                          <button
                            tabIndex={0}
                            className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-center gap-8 fw-medium w-100"
                            onClick={() => handleAddtoCart(product)}
                            disabled={product?.stockQuantity === 0}
                          >
                            Add To Cart <i className="ph ph-shopping-cart" />
                          </button>
                        )}
                        {cartItem && (
                          <QuantityControl
                            currentItem={{ ...product, ...cartItem }}
                          />
                        )}
                        {/* <button
                      className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                      tabIndex={0}
                      disabled={product?.stockQuantity === 0}
                    >
                      Add To Cart <i className="ph ph-shopping-cart" />
                    </button> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img1.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                  <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Best Sale{" "}
                  </span>
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img2.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img3.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Sale 50%{" "}
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img4.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img5.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img6.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img7.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img8.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Sale 50%{" "}
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img9.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img10.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img11.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-warning-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    New
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img12.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img13.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img14.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Best Sale{" "}
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img15.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-warning-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    New
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img15.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img1.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                  <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Best Sale{" "}
                  </span>
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img2.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <img
                    src="assets/images/thumbs/product-two-img3.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
              <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                  to="/product-details-two"
                  className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                  <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                    Sale 50%{" "}
                  </span>
                  <img
                    src="assets/images/thumbs/product-two-img4.png"
                    alt=""
                    className="w-auto max-w-unset"
                  />
                </Link>
                <div className="product-card__content mt-16">
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                      to="/product-details-two"
                      className="link text-line-2"
                      tabIndex={0}
                    >
                      Taylor Farms Broccoli Florets Vegetables
                    </Link>
                  </h6>
                  <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">4.8</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">
                      (17k)
                    </span>
                  </div>
                  <div className="mt-8">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-4"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={35}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-main-two-600 rounded-pill"
                        style={{ width: "35%" }}
                      />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                      Sold: 18/35
                    </span>
                  </div>
                  <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                      $28.99
                    </span>
                    <span className="text-heading text-md fw-semibold ">
                      $14.99{" "}
                      <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                  </div>
                  <Link
                    to="/cart"
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                    tabIndex={0}
                  >
                    Add To Cart <i className="ph ph-shopping-cart" />
                  </Link>
                </div>
              </div>
            </div> */}
            {/* Pagination Start */}
            <Pagination
              pageIndex={pageIndex}
              handlePagination={handlePagination}
              visiblePages={visiblePages}
              hasNextPage={hasNextPage}
            />
            {/* <ul className="pagination flex-center flex-wrap gap-16 align-items-end mt-auto pt-30">
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  <i className="ph-bold ph-arrow-left" />
                </Link>
              </li>
              <li className="page-item active">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  01
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  02
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  03
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  04
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  05
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  06
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  07
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  <i className="ph-bold ph-arrow-right" />
                </Link>
              </li>
            </ul> */}
            {/* Pagination End */}
          </div>
          {/* Content End */}
        </div>
      </div>
      {/* PRESCRIPTION MODAL */}
      <PrescriptionModal
        isPrescriptionModal={isPrescriptionModal}
        handlePrescriptionModal={handlePrescriptionModal}
        // selectedProduct={selectedProduct}
      />
    </section>
  );
};

export default ShopSectionMain;
